<template>
  <div class="container">
    <table class="profit-title">
      <tr>
        <td>
          <my-title :title="title"></my-title>
        </td>
        <td class="profit-title-chart">
          <el-tooltip class="item"
            effect="light"
            content="图表"
            placement="top">
            <img src="@/assets/images/xitong/chart.png"
              class="chart-action"
              @click="openDialog()" />
          </el-tooltip>
        </td>
      </tr>
    </table>
    <my-divider height="15px"></my-divider>
    <el-row>
      <el-col :span="12"
        v-for="(item, i) in data"
        :key="i"
        style="text-align: center">
        <name-value-vertical-with-unit :name="item.name"
          :value="item.value"
          :unit="item.unit"></name-value-vertical-with-unit>
        <my-divider height="30px"
          v-if="i===1"></my-divider>
      </el-col>
    </el-row>
    <el-dialog :title="title"
      :visible.sync="show">
      <div style="">
        <el-radio-group v-model="period"
          @change="change($event)">
          <el-radio-button label="日"></el-radio-button>
          <el-radio-button label="月"></el-radio-button>
          <el-radio-button label="年"></el-radio-button>
        </el-radio-group>
        <my-divider height="20px"></my-divider>
        <div class="container-echarts-electricity">
          <omit-line :id="id"
            v-if="chartsData.xData.length>0"
            :chartsData="chartsData"></omit-line>
          <el-empty description="无数据"
            v-else></el-empty>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MyTitle from "@/components/MyTitle";
import MyDivider from "@/components/MyDivider";
import NameValueVerticalWithUnit from "@/components/zixitong/airSystem/NameValueVerticalWithUnit";
import OmitLine from "@/components/EChartsFolder/OmitLine";

export default {
  name: "NameValueWithDialog",
  components: { OmitLine, NameValueVerticalWithUnit, MyDivider, MyTitle },
  props: {
    id: {
      type: String,
      required: true,
      default: "",
    },
    title: {
      type: String,
      required: true,
      default: "",
    },
    data: {
      type: Array,
      required: true,
      default: [],
    },
    chartsData: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      period: "日",
      show: false,
    };
  },
  methods: {
    openDialog() {
      const startTimeDay = parseInt(this.$moment().startOf("day").format("x")); // 当天零点时间戳
      const endTimeDay = parseInt(this.$moment().endOf("day").format("x")); // 当天23:59:59时间戳

      let data = {
        startTime: startTimeDay,
        endTime: endTimeDay,
        period: this.period,
      };

      this.show = true;
      this.$emit("openDialog", data);
    },
    change(data) {
      const startTimeDay = parseInt(this.$moment().startOf("day").format("x")); // 当天零点时间戳
      const endTimeDay = parseInt(this.$moment().endOf("day").format("x")); // 当天23:59:59时间戳

      const startTimeMonth = parseInt(
        this.$moment().startOf("month").format("x")
      ); // 本月1号零点时间戳
      const endTimeMonth = parseInt(this.$moment().endOf("month").format("x")); // 本月31号23:59:59时间戳

      const startTimeYear = parseInt(
        this.$moment().startOf("year").format("x")
      ); // 本年1月1号零点时间戳
      const endTimeYear = parseInt(this.$moment().endOf("year").format("x")); // 本年12月31号23:59:59时间戳

      let startTime = 0;
      let endTime = 0;
      if (data === "日") {
        startTime = startTimeDay;
        endTime = endTimeDay;
      } else if (data === "月") {
        startTime = startTimeMonth;
        endTime = endTimeMonth;
      } else if (data === "年") {
        startTime = startTimeYear;
        endTime = endTimeYear;
      } else {
        startTime = startTimeDay;
        endTime = endTimeDay;
      }

      let value = { startTime: startTime, endTime: endTime, period: data };
      this.$emit("periodChange", value);
    },
  },
};
</script>

<style scoped lang="scss">
div.container-echarts-electricity {
  height: 450px;
}

img.chart-action {
  width: 20px;
}

img.chart-action:hover {
  cursor: pointer;
}

td.profit-title-chart {
  text-align: right;
}

table.profit-title {
  width: 100%;
}

div.container {
  background-color: #ffffff;
  padding: 10px;
  border-radius: 6px;
  height: 230px;
}
</style>
